import { PdIconPicker } from "./pd-icon-picker/PdIconPicker.js";
//#region src/pd-icon-picker/pd-icon-picker.ts
var tag = "pd-icon-picker";
if (!customElements.get(tag)) customElements.define(tag, PdIconPicker);
//#endregion
export { PdIconPicker };
